'use client'
import type { ReactNode } from 'react'

type Tone = 'neutral' | 'ok' | 'warn' | 'danger' | 'info'

const COLORS: Record<Tone, { bg: string; text: string; border: string }> = {
  neutral: { bg: '#f4f2f0', text: '#5c5652', border: '#dbd7d2' },
  ok:     { bg: '#d4edda', text: '#155724', border: '#c3e6cb' },
  warn:   { bg: '#fff3cd', text: '#856404', border: '#ffeaa7' },
  danger: { bg: '#f8d7da', text: '#721c24', border: '#f5c6cb' },
  info:   { bg: '#d1ecf1', text: '#0c5460', border: '#bee5eb' },
}

export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  const c = COLORS[tone]
  return (
    <span style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border, height: 32 }} className="inline-flex items-center gap-1.5 rounded-sm border px-2 font-medium text-[13px] leading-none whitespace-nowrap">
      {children}
    </span>
  )
}
